export default "__VITE_ASSET__DiqOn2J3__"